

function ViewportsResizeBehaviour(vps, refEl, ratio) {

    const r = ratio || 1;

    return {
        resize: () => {
            const rect1 = refEl.getBoundingClientRect();
            let w = Math.round(rect1.width * r);
            if (w % 2 > 0)
                w--;

            vps.forEach(el => {
                el.style.width = el.style.height = `${w}px`;
            });
        },
        clear: () => {
            vps.forEach(el => {
                el.style.width = '';
                el.style.height = '';
            });
        }
    };
}

module.exports = ViewportsResizeBehaviour;


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/behaviors/ViewportsResizeBehaviour.js